import { IconProps } from "./icon.type";

export function IcFlashOn({ ...props }: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="url(#paint0_linear_2392_817)" />
      <path d="M20.5 15H15.8L19 6.5H13.5L10.5 17H14.8L12.5 26.5L20.5 15Z" fill="#FFDA44" />
      <defs>
        <linearGradient
          id="paint0_linear_2392_817"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A4D5" />
          <stop offset="1" stopColor="#0168ED" />
        </linearGradient>
      </defs>
    </svg>
  );
}
